// 产品(陈玲)希望，不希望统一跳转到我们的收费管家页面“/wallet”，在我们的收费管家页面去判断是否跳转中台
// 这样的话，就需要返回再次才能返回到相应的页面
// 所以，这里写一个minix，在有需要的地方用
export default {
  methods: {
    toOpenSfgj () {
      this.showLoading();
      this.$api.fundsGetSfgjInfo()
        .then(res=> {
          if (res.code === 200) {
            this.$toast.clear();
            this.sfgjInfo = res.data;
            if (res.data && res.data.hasMch) {
              this.$router.push('/walletSuccess');               
              return false;
            }
            if (!app.teacher.user.superAdmin) {      
              this.$router.push('/wallet');      
              return false;
            }
            if (res.data && res.data.isOpenSfgj && res.data.sfgjUrl) {   
              window.location.href = res.data.sfgjUrl;
              return false;
            }
            this.$router.push('/wallet');  
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          if (!err || !err.code) {
            console.log(err);    
            this.$toast.fail(err.msg || '网络异常，请稍后重试');
          }
        });
    }
  }
}